<div class="chip px-3 pb-2" *ngIf="tags">
  <mat-chip-list>
    <!-- Mat chip iteration-->
    <mat-chip *ngFor="let tag of tags">{{ tag | titlecase | trimSpecialCharacters | translate }}</mat-chip>
    <!-- / Mat chip iteration-->
  </mat-chip-list>
</div>
